<template>
  <ElDialog
    @before-close="onBeforeCloseModal"
    :title="$t('companySettings.billing.invoicePreview.purchaseCreditsTitle')"
    v-on="$listeners"
    :visible="show"
    append-to-body
  >
    <VLoadingSpinner v-if="loading" />
    <VMessage
      type="warning"
      :fullwidth="true">
      <template v-slot:icon>
        <ExclamationTriangleIcon />
      </template>
      <template v-slot:text>
        {{ $t('companySettings.billing.addCreditsDDBlock.explaination') }}
      </template>
    </VMessage>
    <div class="p-dd-block-modal__text-margin"><span>{{ $t('companySettings.billing.addCreditsDDBlock.selectDifferentMethod') }}</span></div>
    <div class="p-dd-block-modal__method-container-max-size">
    <template>
      <ElRadio id="method" class="p-dd-block-modal__method" v-model="selectedMethod" :label="method" v-for="method in cardOnlyPaymentMethods" :key="method.id" data-hj-suppress>
        <div class="p-dd-block-modal__card-info-margin">
          <div class="p-dd-block-modal__card-info">
            <span>
              <b>{{ method.card.brand }} ({{ $t(`companySettings.billing.paymentMethods.funding.${method.card.funding}`) }})</b> - {{ $t('companySettings.billing.paymentMethods.ending') }} <b>{{ method.card.last4 }}</b>
            </span>
          </div>
          <div>
            <span>
              {{ $t('companySettings.billing.paymentMethods.expires') }} {{ method.card.exp_month }}/{{ method.card.exp_year }}
            </span>
          </div>
        </div>
      </ElRadio>

    </template>
    </div>
    <VForm :onSubmit="openCreditsModal">
      <div slot="formButtons">
        <VButton type="outline-1" class="float-left" @click.native="showPaymentMethodModal = true;">
          <PlusIcon />
          <span>{{ $t('companySettings.billing.paymentMethods.addPaymentMethod') }}</span>
        </VButton>
        <VButton
          type="cta-1"
          class="float-right"
          subtype="submit"
          :disabled="!selectedMethod"
          data-ec="billing_add_credits_dd_block_modal"
          data-et="confirm_button">
          <CheckIcon />
          <span>{{ $t('functional.confirm') }}</span>
        </VButton>
      </div>
    </VForm>
    <AddCreditsModal :show="showCreditsModal" @close="showCreditsModal = false;" />
     <AddPaymentMethodModal :omitDD="true" :show="showPaymentMethodModal" @close="showPaymentMethodModal = false;" />
  </ElDialog>
</template>

<script>
import { mapGetters } from 'vuex';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import AddPaymentMethodModal from '@/views/modals/payment/AddPaymentMethodModal.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import AddCreditsModal from '@/views/modals/payment/AddCreditsModal.vue';
import { CheckIcon, ExclamationTriangleIcon, PlusIcon } from '@/components/icons/fontIcons';

export default {
  name: 'AddCreditsDirectDebitBlockModal',
  components: {
    VMessage,
    AddCreditsModal,
    AddPaymentMethodModal,
    VForm,
    VButton,
    VLoadingSpinner,
    CheckIcon,
    PlusIcon,
    ExclamationTriangleIcon,
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      showPaymentMethodModal: false,
      showCreditsModal: false,
      loading: false,
      selectedMethod: undefined,
    };
  },
  computed: {
    ...mapGetters({
      paymentMethods: 'paymentMethods/results',
    }),
    cardOnlyPaymentMethods() {
      return this.paymentMethods.filter(method => method.type !== 'Source');
    },
  },
  methods: {
    onBeforeCloseModal() {
      const scope = this.$refs.form.$el.getAttribute('data-vv-scope');
      this.errors.clear(scope);
      return true;
    },
    closeModal() {
      this.loading = false;
      this.$emit('close');
    },
    async openCreditsModal() {
      if (this.selectedMethod) {
        this.loading = true;
        await this.$store.dispatch('paymentMethods/SWITCH_DEFAULT_METHOD', { id: this.selectedMethod.id });
        await this.$store.dispatch('paymentMethods/GET');
        this.closeModal();
        this.showCreditsModal = true;
      }
    },
  },
};
</script>

<style scoped>
.p-dd-block-modal__text-margin {
  margin: var(--spacing-base) 0;
}
.p-dd-block-modal__method-container-max-size {
  max-height: 300px;
  overflow: scroll;
}
.p-dd-block-modal__method {
  width: 100%;
  border: 1px solid var(--color-border);
  margin: var(--spacing-small) 0;
  padding: var(--spacing-base);
  display: flex;
  flex-direction: row;
  align-items: center;
}
.p-dd-block-modal__card-info-margin {
  margin-left: var(--spacing-base);
}
.p-dd-block-modal__card-info {
  margin-bottom: var(--spacing-xs);
}
</style>
